import { laptopMediumMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { QuestionList, QuestionListItem } from './FaqList.style';

export const RelatedArticles = styled.div`
  flex-basis: 350px;
  background-color: #f8f8f8;

  /* if changing media query, also update RelatedArticlesContainer 
  & FaqMainContentContainer in FaqContentContainer.style */
  @media (${laptopMediumMin}) {
    flex-basis: 350px;
  }
`;

export const RelatedArticlesContainer = styled.div`
  padding: 30px;

  @media (${laptopMediumMin}) {
    margin-top: 80px;
  }
`;

export const RelatedArticlesList = styled(QuestionList)`
  margin-top: 20px;
`;

export const RelatedArticlesListItem = styled(QuestionListItem)`
  font-weight: 400;
  border-color: ${({ theme }) => theme.backgroundLight};
`;
